import type React from 'react';

import { TabList, Tabs } from '@change/ds-core-ui';

import { usePageTabs } from './hooks/usePageTabs';

export const PageTabs: React.FC = () => {
	const {
		data: { activeTab, items },
	} = usePageTabs();

	return (
		<Tabs selectedKey={activeTab} data-qa="tab-links">
			<TabList items={items} />
		</Tabs>
	);
};
